import { type AuthConfig } from "@pasta/front-auth-v2";

export interface ParapheurConfig extends AuthConfig {
  fileSizeLimit: string;
  bnumUrl?: string;
  exportPollInterval?: number;
  exportTimeout?: number;
  cguLink: string;
  accessibilityDeclarationLink: string;
  signatures: {
    max: number;
    extensions: string[];
    fileSizeLimit: string;
  };
  beta?: boolean;
  tutoPdfLink?: string;
  graphicsChartLink?: string;
  goodpracticesLink?: string;
  tchapLink?: string;
  allowedConversionFormats: string[];
  socketio: {
    transport: string[];
  };
  disableChooseReaderModal: boolean;
}

export enum NotificationType {
  AT_YOUR_LEVEL = "AT_YOUR_LEVEL",
  CC = "CC",
  ARCHIVED_OR_DELETED = "ARCHIVED_OR_DELETED",
  SIGNED = "SIGNED",
  DEADLINE = "DEADLINE",
  COMMENT = "COMMENT",
}

export interface LetterFileEventData {
  userId: number;
  userName: string;
  letterFileId: number;
}

export * from "./form-operation.enum";
